import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { GestureResponderEvent, ImageSourcePropType, StyleSheet, Text, View, ScrollView } from 'react-native';
import { GameObject } from '../../../../store/slices/gameObjectSlice';
import { GalleryButton } from '../GalleryButton';
import { replayScenesList, ScenesReplayListKey } from './scenesReplayData';
import * as funcs from "../../../../components/functions";
import { jump } from '../../../../shell/jump';
import { useDispatch, useSelector } from 'react-redux';
import menuSlice, { selectMenu, setMenu } from '../../../../store/slices/menuSlice';
import { setAdvance } from '../../../../store/slices/AdvanceSlice';
import Game from '../../../../shell/Game';
import { store } from '../../../../store/store';
import { Action } from '../../../../shell/Actions/Action';
import { GameNames } from '../../../../store/slices/GameTypes';
import Character from '../../../../shell/Character';
import { useAppSelector } from '../../../../store/hooks';
import { MenuOptions } from '../../SideBar';
import { Checkbox } from '../../../checkbox/Checkbox';

export type GalleryTags = 'HANDJOB' | "BLOWJOB" | "VAGINAL" | "ANAL" | "SOLO" | "PINUP" | "FOREPLAY" | "FOOTJOB" | "NTR" | "THREESOME" | "PUSSYLICK";

export interface TScenesReplay {
    imageKey: string;
    text: string,
    page: number;
    tags: GalleryTags[],
    scene: string,
    ID: ScenesReplayListKey,
    seen: boolean;
    chars: ("vanessa" | "ann" | "jenny" | "amber" | "alex" | "emily" | "merry" | "angela" | "kim")[];
    gameState: GameObject | null;


}

interface ScenesReplayProps {

}

export const ScenesReplay: React.FC<ScenesReplayProps> = ({ }) => {
    const [sceneData, setSceneData] = useState<{ [key: string]: TScenesReplay; }>();
    // const scrollViewRef = React.useRef<ScrollView>(null);
    const menuSlice = useAppSelector(selectMenu);
    const [checkedNTR, setCheckedNTR] = useState(true);
    // const scrollPos = useRef<number>();
    // if (store.getState().menu.sceneReplayScrollPos && menuSlice.menuState === MenuOptions.SCENES && scrollViewRef.current) {
    //     scrollViewRef.current.scrollTo(store.getState().menu.sceneReplayScrollPos, 0, false);
    // }
    const dispatch = useDispatch();
    const styles = StyleSheet.create({
        container: {
            marginBottom: 20,
            marginTop: 5,
            flex: 1,
            marginLeft: 15,
            flexWrap: "wrap",
            flexDirection: "row",
            height: "100%",
            alignContent: "center",
        },

    });
    const setSeenScenes = async () => {
        const persistent = await global.electronAPI?.getPersistent();
        const gallery = persistent?.gallery;
        if (!gallery) {
            // TODO: throw error
            setSceneData(replayScenesList);
            return;
        }
        Object.keys(replayScenesList).forEach((scene) => {
            const key = scene as ScenesReplayListKey; // type assertion
            if (gallery[scene]?.seen) {
                // TODO: change to this
                replayScenesList[key].seen = gallery[scene].seen;
                replayScenesList[key].gameState = gallery[scene].gameState;
            }
            // replayScenesList[key].seen = true;
        });
        setSceneData(replayScenesList);


    };
    useLayoutEffect(() => {



    }, [menuSlice.menuState]);


    useEffect(() => {
        setSeenScenes();

        // return () => {
        //     if (scrollPos.current) {

        //         store.dispatch(setMenu({ sceneReplayScrollPos: scrollPos.current }));
        //     }
        // };

    }, []);


    const onPressed = (e: GestureResponderEvent, _scene: TScenesReplay) => {
        const scene = JSON.parse(JSON.stringify(_scene));
        if (!scene.seen) {
            return;

        }
        Action.head = null;
        Game.Action = null;

        Game.isReplayRunning = _scene;
        Game.rollback = 0;
        // if (store.getState().gameObject.present.lastUpdated !== GameNames.INIT) {
        //     Game.replayState = store.getState();
        // } else {
        //     Game.replayState = null;

        // }

        Game.replayState = store.getState();
        Character.initCharacters();
        if (!scene.gameState) {
            scene.gameState = JSON.parse(JSON.stringify(store.getState().gameObject.present)) as GameObject;

        }

        scene.gameState.talk.text = '        '; //fake input so it will jump to the start of the scene
        scene.gameState.talk.options = { hideText: true };

        scene.gameState.lastUpdated = GameNames.TALK; //fake input so it will jump to the start of the scene
        scene.gameState.currentScene = scene.scene;
        store.dispatch(setMenu({ display: false, loading: true }));
        dispatch({ type: "GAME_OBJECT_CLEAR" });
        const payload = { ...store.getState(), gameObject: { ...store.getState().gameObject, present: scene.gameState } };
        // store.dispatch({ type: "reset", payload });

        // @ts-ignore-start
        // jump(funcs[scene.gameState.currentScene], scene.gameState.currentScene);


        setTimeout(() => {


            Action.searchScene({ scene: scene.gameState, promiseData: false, potentialNode: null }, true);

        });

        // jump(scene.scene, scenes["AnnAfterTODLoveBJ"]?.());


    };
    // const handleScroll = (event: any) => {
    //     console.log(scrollViewRef.current);
    //     scrollPos.current = event.nativeEvent.contentOffset.y;
    // };

    return (
        <View style={{
            height: "100%",
            display: "flex",
            paddingRight: 20,
            marginBottom: "1S%",
            paddingLeft: 20,

        }}>
            <View>
                <Checkbox label='NTR?' checked={checkedNTR} onCheck={() => {
                    setCheckedNTR(!checkedNTR);
                }}></Checkbox>
            </View>
            <ScrollView style={{
                paddingBottom: "15%"


            }}>
                {sceneData ?
                    <View style={styles.container}>
                        {Object.keys(sceneData).filter(key => {
                            if (checkedNTR) {
                                return true;
                            }
                            return sceneData[key].tags.includes("NTR");
                        }).map((key, val) => {

                            return <GalleryButton onPress={(e) => onPressed(e, sceneData[key])} key={key} scene={sceneData[key]}></GalleryButton>;
                            // return <View key={key}>
                            //     <GalleryButton onPress={(e) => onPressed(e, sceneData[key])} scene={sceneData[key]}></GalleryButton>
                            // </View>;


                        })}
                    </View> : <></>
                }
            </ScrollView>
        </View>
    );
};